import IconButton from '@/_application/core/components/ui/icon-button';
import {Image} from '@/_application/core/components/ui/image';
import ProductLoader from '@/_application/core/components/ui/loaders/product-loader';
import {getImageAssetUrl} from '@/_application/core/utils/common';
import {ProductCard} from '@/_application/modules/products/components/cards/product-card';
import {Product} from '@/_application/modules/products/model/product';
import {useNewArrivalProducts} from '@/framework/products-promotion';
import rangeMap from '@/lib/range-map';
import {useTranslation} from 'next-i18next';
import {useState} from 'react';
import {LazyLoadBlock} from '@/_application/core/components/commons/lazy-load-block';

const BlueNextArrowIcon = getImageAssetUrl('icons/blue-next-arrow.png');

const NewArrivalProductsMobile = () => {
    const {t} = useTranslation();
    const {newArrivalProducts, isLoading} = useNewArrivalProducts();

    const [limit, setLimit] = useState(4);

    const handleOnClick = () => {
        setLimit(pre => pre + 6);
    };

    return (
        <div className="mx-4 mt-4">
            <div className="grid grid-cols-1 gap-4 pb-4 xs:grid-cols-2 sm:grid-cols-3">
                {isLoading && rangeMap(4, i => <ProductLoader key={i} uniqueKey={`product-${i}`} />)}

                {!!newArrivalProducts?.length &&
                    (newArrivalProducts as Product[])
                        ?.filter((_, index) => index < limit)
                        .map(product => (
                            <LazyLoadBlock isLazyLoad={true}>
                                <ProductCard key={product?.sku} product={product} className="" />
                            </LazyLoadBlock>
                        ))}
            </div>
            <div className="flex justify-center items-center">
                {limit < newArrivalProducts?.length && (
                    <IconButton
                        whileTap={{translateY: 6, backgroundColor: '#21409A', opacity: 0.5}}
                        transition={{ease: 'easeOut'}}
                        onClick={handleOnClick}
                        className="mx-auto flex flex-row-reverse content-center items-center justify-center rounded-2xl px-3 py-2"
                        icon={
                            <Image
                                src={BlueNextArrowIcon}
                                alt="Icon"
                                width={8}
                                height={10}
                                className="ml-2 rotate-90 transform"
                            />
                        }
                        label={t('text-load-more')}
                        labelClassName="text-primary text-xs"></IconButton>
                )}
            </div>
        </div>
    );
};

export default NewArrivalProductsMobile;
